import { FolderOverviewFeatureState, FolderScopeDetails, FolderScopesState } from '../models'

import { Preference } from '@app/core/model/user-preferences.interface'
import { TableColumnPreferences } from '@app/shared/components/ui-components/scope-ui-table/table-column-preferences.type'
import { createSelector } from '@ngrx/store'
import { getFolderOverviewFeatureState } from '../reducers'

const selectFolderScopesState = createSelector(
  getFolderOverviewFeatureState,
  (state: FolderOverviewFeatureState): FolderScopesState => state.folderScopes
)

const selectIsLoadingTable = createSelector(
  selectFolderScopesState,
  (state: FolderScopesState): boolean => state?.isLoadingTable
)

const selectColumns = createSelector(
  selectFolderScopesState,
  (state: FolderScopesState): TableColumnPreferences => state?.columns
)

const selectDisplayedColumns = createSelector(selectColumns, (columns: TableColumnPreferences): Preference[] =>
  Object.values(columns)
)

const selectScopeDetailsMap = createSelector(
  selectFolderScopesState,
  (state: FolderScopesState): FolderScopeDetails => state?.scopeDetails
)

export const FolderScopesSelectors = {
  selectFolderScopesState,
  selectIsLoadingTable,
  selectColumns,
  selectDisplayedColumns,
  selectScopeDetailsMap,
}
